class ObservableStore {
  constructor(defaulState = {}) {
    this._state = defaulState;
    this._subscribers = new Set();
  }

  subscribe = (cb) => {
    this._subscribers.add(cb);
    return () => this._subscribers.delete(cb);
  };

  notify = (state) => {
    this._subscribers.forEach((cb) => cb(state));
  };

  setProps = (props) => {
    this._state = { ...this._state, ...props };
    this.notify(this._state);
  };

  getState = () => this._state;
}

export default ObservableStore;
